import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import axios from 'axios';

import {useracc, postApi, putApi, deleteApi, bytesToSize, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';
//import VideoPlayer from '../components/video/video';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import File from '../components/bbcode/file';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import moment from 'moment';
//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import './css/filemanager.css';
//import './css/header.css';

class PortalServiceFiles extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: this.props.service,
				name: '',
			},

			

      directory: [],
			contents: [],
			statistics: {current: 0, max: 0, percent: 0},
			recent: [],

			modal: false,
			setting: '',
			source: false,
			rename: '',
      process: false,
			uploads: [],
		};
    this.getFiles = this.getFiles.bind(this);
		
		this.handleChange = this.handleChange.bind(this);
		this.submitMkdir = this.submitMkdir.bind(this);
		this.clickuploadFile = this.clickuploadFile.bind(this);
		this.uploadFiles = this.uploadFiles.bind(this);
		this.submitRename = this.submitRename.bind(this);
		this.submitDelete = this.submitDelete.bind(this);
		this.upload = this.upload.bind(this);
		this.chdir = this.chdir.bind(this);
		this.rename = this.rename.bind(this);
		this.delete = this.delete.bind(this);
		this.close = this.close.bind(this);
  };

  async componentDidMount() {
		//document.title = "";

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		
		//value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', y);

		this.getFiles();
   
		
	}

	componentWillUnmount() {
    
	}

	async getFiles() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('directory', this.state.directory.join('/'));
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/service/filemanager`, params);
		
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('File Manager', x.data.servicename);
			}
			this.setState({contents: [], statistics: {current: 0, max: 0, percent: 0}, recent: []}, ()=>{this.setState({statistics: x.data.statistics, contents: x.data.files, recent: x.data.recent});});
		}
	}


	handleChange(event) {
		let item = event.target.value.replaceAll(/[^a-zA-Z0-9._\s-:]*/g, '');
		if( event.target.name === "setting" ) this.setState({setting: item});
	}

	async submitMkdir(e) {
		e.preventDefault();
		
		this.setState({process: true},async ()=>{
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('mkdir', this.state.setting);
			params.append('directory', this.state.directory.join('/'));
			const x = await postApi(`${this.context.worker[this.props.service]}/v3/service/filemanager/create`, params);
			
			if( x.status === 200 ) {
				this.close();
			} else {
				this.setState({process: false});
			}
		});
	}

	async clickuploadFile() {
		document.getElementById('upload').click();
	}

	async uploadFiles(event) {
		
		for (let i in Array.prototype.slice.call(event.target.files)) {
			

			const blobToData = (blob) => {
				return new Promise((resolve) => {
					const reader = new FileReader();
					reader.onloadend = () => resolve(reader.result);
					reader.readAsDataURL(blob);
				})
			}
			let result = await blobToData(event.target.files[i]);

			let x = {
				filename: event.target.files[i].name,
				thumbnail: result,
				filesize: event.target.files[i].size,
				percent: 0,
				complete: false,
				error: false
			};

			let uploads = this.state.uploads;
			uploads.push(x);
			this.setState({uploads});

			const params = new FormData();
			params.append('service', this.state.service.id);
			params.append('directory', this.state.directory.join('/'));
			params.append('files', event.target.files[i]);

			axios.put(`${this.context.worker[this.props.service]}/v3/service/filemanager`, params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true,
				onUploadProgress: (progressEvent) => {
					let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
					let _uploads = this.state.uploads;
					for( let j in _uploads ) {
						if( _uploads[j].filename === event.target.files[i].name && _uploads[j].percent !== percentCompleted ) {
							_uploads[j].percent = percentCompleted;
							this.setState({uploads: _uploads});
						}
					}
				}
			}).then((status)=>{
				
				let _uploads = this.state.uploads;
				for( let k in _uploads ) {
					if( _uploads[k].filename === event.target.files[i].name ) {
						if( status.status === 200 ) {
							_uploads[k].complete = true;
						} else {
							_uploads[k].error = status.data;
						}
						this.setState({uploads: _uploads});
					}
				}
				if( status.status === 200 )
					setTimeout(()=>{
						let __uploads = this.state.uploads;
						for( let k in __uploads ) {
							if( __uploads[k].filename === event.target.files[i].name ) {
								uploads.splice(k, 1);
								this.setState({uploads: __uploads});
							}
						}
					}, 5000);
			}).catch(()=>{
				let _uploads = this.state.uploads;
				for( let k in _uploads ) {
					if( _uploads[k].filename === event.target.files[i].name ) {
						_uploads[k].error = true;
						this.setState({uploads: _uploads});
					}
				}
			});
		}
	}

	async submitRename(e) {
		e.preventDefault();
		this.setState({process: true},async ()=>{
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('source', this.state.contents[this.state.source].filename.split('/').pop());
			params.append('rename', this.state.setting);
			params.append('directory', this.state.directory.join('/'));
			const x = await putApi(`${this.context.worker[this.props.service]}/v3/service/filemanager/rename`, params);
			
			if( x.status === 200 ) {
				this.close();
			} else {
				this.setState({process: false});
			}
		});
	}


	async submitDelete(e) {
		e.preventDefault();
		this.setState({process: true},async ()=>{
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('rmdir', this.state.setting);
			params.append('directory', this.state.directory.join('/'));
			const x = await deleteApi(`${this.context.worker[this.props.service]}/v3/service/filemanager/delete`, params);
			if( x.status === 200 ) {
				this.close();
			} else {
				this.setState({process: false});
			}
		});
	}

	async upload() {
		if( this.state.modal === false ) {
			this.setState({modal: 'upload'});
		} else {
			this.close();
		}
	}

	async chdir(source) {
		let directory = this.state.directory;
		switch(typeof source) {
			case 'string':
				directory.push(source);
			break;
			case 'number':
				directory.splice(source);
			break;
			default: break;
		}
		this.setState({directory},()=>{
			this.getFiles();
		});
	}


	async mkdir() {
		if( this.state.modal === false ) {
			this.setState({modal: 'mkdir'});
		} else {
			this.close();
		}
	}

	async rename(source) {
		if( this.state.modal === false ) {
			for( let i in this.state.contents ) {
				if( this.state.contents[i].filename.endsWith(source) ) {
					
					this.setState({modal: 'rename', setting: source, source: parseInt(i)});
				}
			}
			
		} else {
			this.close();
		}
	}

	async delete(source) {
		if( this.state.modal === false ) {
			for( let i in this.state.contents ) {
				if( this.state.contents[i].filename.endsWith(source) ) {
					consoleLog(this.state.contents[i]);
					this.setState({modal: 'delete', setting: source, source: parseInt(i)});
				}
			}
			//this.setState({modal: 'delete', setting: source, source});
		} else {
			this.close();
		}
	}



	async close() {
		this.setState({modal: false, setting: '', source: '', process: false},()=>{
			this.getFiles();
		});
	}

  
	render() {
		const user = this.context;

		const directories = Object.keys(this.state.directory).map((e,i) => {
			return (
				<Button key={i} size="sm" variant='light' onClick={()=>this.chdir(i+1)}>{this.state.directory[e]}</Button>
			)
		});
		const contents = Object.keys(this.state.contents).map((e,i) => {
			return (
				<Col md={6} lg={4} key={i} className="mb-3">
					<File
						server={this.context.worker[this.props.service]}
						file={this.state.contents[e]}
						chdir={this.chdir}
						rename={this.rename}
						delete={this.delete} />
				</Col>
			)
		});
		const recent = Object.keys(this.state.recent).map((e,i) => {
			let filename = this.state.recent[e].filename.split('/');
			return (
				<tr key={i}>
					<th scope="row">
						<div className="d-flex align-items-center">
							<div className="me-2"> <span className="avatar avatar-xs"> <img src="https://cloud1.ultrastream.io/images/filemanager/.png" alt="" /> </span> </div>
							<div className="fs-13"> {filename[filename.length-1]} </div>
						</div>
					</th>
					<td>{filename[filename.length-2]}</td>
					<td>{bytesToSize(this.state.recent[e].size)}</td>
					<td>{moment(this.state.recent[e].mtime).format("dddd, Do MMMM")}</td>
				</tr>
			)
		});

		const uploads = this.state.uploads.map((e,i) => {
			return (
				<Col xs={12} key={i} className="mb-1">
					<Row className="gx-0" style={{border: '1px solid #ccccccaa', borderRadius: 5}}>
						<div className="text-mcenter py-1" style={{width: 120}}>
							<img src={e.thumbnail} width={90} alt='' style={{minHeight: 60, backgroundColor: '#f4f4f4', border: '1px solid #444444', borderRadius: 5}} />
						</div>
						<Col className="text-mcenter" style={{paddingRight: 20}}>
							<div style={{width: '100%'}}>

								{e.filename} <span className="text-muted">{bytesToSize(e.filesize)}</span>
								
								<br />
								<div className="progress progress-sm progress-custom my-1 progress-animate" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
									<div className="progress-bar" style={{width: `${e.percent}%`}}>
										<div className="progress-bar-value">{e.percent}%</div>
									</div>
								</div>
								{e.complete === true &&<>&nbsp;
									<span className="badge bg-outline-success"><FontAwesomeIcon icon="check" /> Completed</span>
								</>}
								{e.error !== false &&<>&nbsp;
									<span className="badge bg-outline-danger"><FontAwesomeIcon icon="exclamation" /> {e.error}</span>
								</>}
							</div>
						</Col>
					</Row>
				</Col>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">File manager</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">File manager</span>
													<p className="fs-13 text-muted mb-0">Share and organise Files, Drops and Jingles with your group</p>
												</div>
                      </div>
											<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                    </div>
										{/*<div className="card-body ">
											Admin Controls / Create Folder / Directory<br />
											<Button size="sm">Create Directory</Button>
										</div>*/}
                  </div>
                </Col>
              </Row>


							<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
											<div className="d-flex">
												<div>
													<Button size="sm" variant='light' onClick={()=>this.chdir(this.state.directory.length-1)} disabled={this.state.directory.length===0?true:false}><FontAwesomeIcon icon="turn-up" /></Button>
													<Button size="sm" variant='light' onClick={()=>this.chdir(0)}>Shared Files</Button>
													{directories}
												</div>
											</div>
											<div className="d-flex">
												<Button size="sm" onClick={()=>this.mkdir()}>+ Add Directory</Button>
												<Button size="sm" onClick={()=>this.upload()}>+ Upload Files</Button>
											</div>
										</div>
									</div>
								</Col>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-body">
											<Row>
												{contents}
											</Row>
										</div>
									</div>
								</Col>
							</Row>


							<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												Storage & Recent
                      </div>
                    </div>
                    <div className="card-body">
											<Row>
												<Col md={6}>
													<ul className="mt-4">
														<li className="mb-4">
															<div className="d-flex mb-4 align-items-center">
																<div className="me-3"> <span className="avatar avatar-md br-5 bg-warning-transparent text-warning"><FontAwesomeIcon icon="box" /></span> </div>
																<div className="flex-fill">
																	<div className="d-flex justify-content-between">
																		<h6 className="fw-semibold"> Storage </h6>
																		<div>
																			<p className="mb-0 fs-13 text-muted"> <i className="fe fe-arrow-up-right me-1 text-success brround d-inline-flex"></i>{bytesToSize(this.state.statistics.current)} / {bytesToSize(this.state.statistics.max)} </p>
																		</div>
																	</div>
																	<div className="progress progress-xs">
																		<div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" style={{width: `${this.state.statistics.percent}%`}}></div>
																	</div>
																</div>
															</div>
														</li>
													</ul>
												</Col>
												<Col md={12}>
													<div className="table-responsive border border-bottom-0">
														<table className="table text-nowrap table-hover">
															<thead>
																<tr>
																	<th scope="col">File Name</th>
																	<th scope="col">Category</th>
																	<th scope="col">Size</th>
																	<th scope="col">Date Created</th>
																</tr>
															</thead>
															<tbody>
																{recent}
															</tbody>
														</table>
													</div>
												</Col>
											</Row>
										</div>
									</div>
								</Col>
							</Row>
            </div>
					</div>
				}
				{this.state.modal === 'mkdir' &&
					<>
						<Modal show={this.state.modal !== false} onHide={this.close} backdrop="static" keyboard={false} size="lg" centered>
							<Modal.Header closeButton className="">
								<Modal.Title>Create Folder</Modal.Title>
							</Modal.Header>
							<Modal.Body className="">
								<Row>
									<Col xs={12}>
										<Form onSubmit={this.submitMkdir}>
											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="setting" className="col-sm-4 col-form-label col-form-label-sm ps-4">
													<strong>Folder Name:</strong>
												</label>
												<div className="col-md-6 mt-2">
													<Form.Control type="text" name="setting" id="setting" onChange={this.handleChange} value={this.state.setting} className="form-control-sm" />
												</div>
											</div>
										</Form>
									</Col>
								</Row>
							</Modal.Body>
							<Modal.Footer className="">
								<Button size="sm" variant="secondary" onClick={this.close}>Cancel</Button>
								<Button size="sm" variant="primary" onClick={this.submitMkdir} disabled={this.state.process}>Create Folder</Button>
							</Modal.Footer>
						</Modal>
					</>
				}
				{this.state.modal === 'upload' &&
					<>
						<Modal show={this.state.modal !== false} onHide={this.close} backdrop="static" keyboard={false} size="lg" centered>
							<Modal.Header closeButton className="">
								<Modal.Title>Upload Files</Modal.Title>
							</Modal.Header>
							<Modal.Body className="">
								<Row>
									<Col xs={12}>
										<div className="upload-image">
											<div className="text-mcenter mb-3">
												<div >
													<img src={`https://cloud.ultrastream.io/images/components/upload.png`} alt="Upload Files" width={360} style={{marginRight: 10, cursor: 'pointer'}} onClick={()=>this.clickuploadFile()} />
												</div>
											</div>
										</div>
									</Col>
									{uploads}
								</Row>
							</Modal.Body>
							<Modal.Footer className="">
								<Button size="sm" variant="secondary" onClick={this.close}>Cancel</Button>
							</Modal.Footer>
						</Modal>
					</>
				}
				{this.state.modal === 'rename' &&
					<>
						<Modal.Header closeButton className="">
							<Modal.Title>Rename {this.state.contents[this.state.source].file===1?'Folder':'File'}</Modal.Title>
						</Modal.Header>
						<Modal.Body className="">
							<Row>
								<Col xs={12}>
									<Form onSubmit={this.submitRename}>
										<div className="form-group row pt-1 pb-0 mb-1">
											<label htmlFor="setting" className="col-sm-4 col-form-label col-form-label-sm ps-4">
												<strong>{this.state.contents[this.state.source].file===1?'Folder':'File'} Name:</strong>
											</label>
											<div className="col-md-6 mt-2">
												<Form.Control type="text" name="setting" id="setting" onChange={this.handleChange} value={this.state.setting} placeholder={this.state.contents[this.state.source].filename.split('/').pop()} className="form-control-sm" />
											</div>
										</div>
									</Form>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer className="">
							<Button size="sm" variant="secondary" onClick={this.close}>Cancel</Button>
							<Button size="sm" variant="primary" onClick={this.submitRename} disabled={this.state.process}>Rename {this.state.contents[this.state.source].file===1?'Folder':'File'}</Button>
						</Modal.Footer>
					</>
				}
				{this.state.modal === 'delete' &&
					<>
						<Modal.Header closeButton className="">
							<Modal.Title>Delete {this.state.contents[this.state.source].file===1?'Folder':'File'}</Modal.Title>
						</Modal.Header>
						<Modal.Body className="">
							<Row>
								{this.state.contents[this.state.source].file===1?
									<>
										<div style={{width: 100}}>
											<div className="mb-4 folder-svg-container d-flex justify-content-between align-items-top">
												<img src={`https://cloud.ultrastream.io/images/filemanager/folder.png`} width={48} height={48} alt="" />
											</div>
										</div>
										<Col>
											<p className="fs-14 fw-semibold mb-1 lh-1">Folder: {this.state.setting}</p>
											<div className="d-flex align-items-center justify-content-between flex-wrap">
												<div> <span className="text-muted fs-12">
													{/*this.state.file.folders && this.state.file.folders>0 ? <>{this.state.file.folders} Folders<br /></>:<></>}
													{this.state.file.files && this.state.file.files>0 ? <>{this.state.file.files} Files<br /></>:<></>*/}
													
													{this.state.contents[this.state.source].folders === 0 && this.state.contents[this.state.source].files === 0 ?
														<>Empty</>
													:
														<>{this.state.contents[this.state.source].folders>0&&<>{this.state.contents[this.state.source].folders} Folders, </>}{this.state.contents[this.state.source].files} Files</>
													}
												</span><br /><br />
												Delete this folder and all of the contents? </div>
												<div> <span className="text-default fw-semibold"> {/*bytesToSize(this.state.file.size)*/} </span> </div>
											</div>
										</Col>
									</>
								:
									<>
										<div style={{width: 100}}>
											<div className="mb-4 folder-svg-container d-flex justify-content-between align-items-top">
												<img src={`https://cloud.ultrastream.io/images/filemanager/folder.png`} width={48} height={48} alt="" />
											</div>
										</div>
										<Col>
											<p className="fs-14 fw-semibold mb-1 lh-1">File: {this.state.setting}</p>
											<div className="d-flex align-items-center justify-content-between flex-wrap">
												<div> <span className="text-muted fs-12"></span><br /><br />
												Are you sure you wish to delete this file? </div>
												<div> <span className="text-default fw-semibold"> {/*bytesToSize(this.state.file.size)*/} </span> </div>
											</div>
										</Col>
									</>
								}
							</Row>
						</Modal.Body>
						<Modal.Footer className="">
							<Button size="sm" variant="secondary" onClick={this.close}>Cancel</Button>
							<Button size="sm" variant="primary" onClick={this.submitDelete} disabled={this.state.process}>Delete {this.state.contents[this.state.source].file===1?'Folder':'File'}</Button>
						</Modal.Footer>
					</>
				}
				<input id="upload" type="file" multiple onChange={this.uploadFiles} style={{display: 'none'}} />
			</>
		);
	}
}

const Files = props => {
  const { service } = useParams();
  return <PortalServiceFiles service={service} {...props} />
}
export default Files;